import React, { useState } from 'react'
import { Modal, MuiTextField } from '../../../../components'
import { ModalButton, ModalTitle, ModalWrapper } from './style'

const UpdateNameModal = ({ onClose, data = [] }) => {
  const [state, setState] = useState('')
  const [errors, setErrors] = useState('')

  const validate = () => {
    const errorObj = {}
    if (!state) {
      errorObj.draftName = 'Name is required'
    }

    setErrors(errorObj)

    return !!Object.keys(errorObj).length
  }

  const onSubmit = () => {
    const isError = validate()
    if (isError) return
  }

  return (
    <Modal title='' showClose={true} onClose={onClose}>
      <ModalWrapper>
        <ModalTitle variant='body1'>Simulation Name</ModalTitle>
        <MuiTextField
          error={Boolean(errors.draftName)}
          fullWidth
          helperText={errors.draftName}
          label='Simulation Name'
          name='draftName'
          onChange={(e) => setState(e.target.value)}
          value={state}
          variant='standard'
        />
        <ModalButton color='primary' variant='contained' onClick={onSubmit}>
          Save
        </ModalButton>
      </ModalWrapper>
    </Modal>
  )
}

export default UpdateNameModal
